<template>
  <div class="container-new-ui" style="background-color: white; border-top: 1px solid #eee; min-height: calc(100vh - 60px)">
    <div class="d-flex align-items-center justify-content-center">
      <div class="container-hut-rewards-detail">
        <div class="container-top">
          <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
            <span class="font-weight-bold text-title">HUT</span>
            <img class="image-reward-desktop" src="https://static.phdvasia.com/jp/hut-rewards/icon_rewards_red.png"/>
            <span class="text-title text-reward">REWARDS</span>
            <span class="text-small-top-right">TM</span>
          </div>
        </div>
        <h6 class="mt-5 mb-5 text-center font-weight-bold">{{ $t('list_available_rewards') }}</h6>
        <PhTabHutRewards :type="1" id="nav-benefit" class-name="nav-benefit" :data="dataTabBenefit" :active-tab="activeTabBenefit" :handle-change-tab="changeTabBenefit">
          <div v-for="(item, i) in dataTabBenefit" :key="i" :class=" i === activeTabBenefit ? 'tab-pane active show' : 'tab-pane fade'">
            <div class="container-accordion">
              <div class="container-item" v-for="(category, j) in generateCategory()" :key="i * j + j">
                <div class="container-title">
                  <span>{{ category.name }} ({{ getValueFromAttr(category, 'dataItems', []).length }})</span>
                </div>
                <div class="container-content collapse show">
                  <PhListItemsHutRewards :data="generateItems(category)" icon="https://static.phdvasia.com/jp/hut-rewards/left_icon.png"></PhListItemsHutRewards>
                </div>
              </div>
            </div>
          </div>
        </PhTabHutRewards>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  created: function () {
    if (this.$route.query && this.$route.query.isApp === '1' && this.$route.query.lang && this.$route.query.lang !== this.$session.get('lang')) {
      this.$i18n.locale = this.$route.query.lang
      this.$session.set('lang', this.$i18n.locale)
      this.$router.go(this.$router.currentRoute)
    }
  },
  mounted: function () {
    if (document.getElementById('container-header-page')) {
      document.getElementById('container-header-page').style.display = 'none'
    }
    this.activeIconBenefit = this.dataTabBenefit[this.activeTabBenefit].iconItem
    this.getAllDataCategoryLoyalty()
  },
  beforeDestroy: function () {
    if (document.getElementById('container-header-page')) {
      document.getElementById('container-header-page').style.display = 'block'
    }
  },
  data () {
    return {
      dataTabBenefit: [
        {
          icon: 'https://static.phdvasia.com/jp/hut-rewards/icon_member.png',
          iconItem: 'https://static.phdvasia.com/jp/hut-rewards/icon_member.png',
          title: this.$t('ranks.member'),
          ranking: 4
        },
        {
          icon: 'https://static.phdvasia.com/jp/hut-rewards/icon_silver.png',
          iconItem: 'https://static.phdvasia.com/jp/hut-rewards/icon_silver.png',
          title: this.$t('ranks.silver'),
          ranking: 3
        },
        {
          icon: 'https://static.phdvasia.com/jp/hut-rewards/icon_gold.png',
          iconItem: 'https://static.phdvasia.com/jp/hut-rewards/icon_gold.png',
          title: this.$t('ranks.gold'),
          ranking: 2
        },
        {
          icon: 'https://static.phdvasia.com/jp/hut-rewards/icon_vip.png',
          iconItem: 'https://static.phdvasia.com/jp/hut-rewards/icon_vip.png',
          title: this.$t('ranks.vip'),
          ranking: 1
        }
      ],
      dataCategory: [],
      activeTabBenefit: 0,
      activeIconBenefit: null,
      ranking: 4
    }
  },
  methods: {
    changeTabBenefit (index) {
      this.activeTabBenefit = index
      this.activeIconBenefit = this.dataTabBenefit[index].iconItem
      this.ranking = this.dataTabBenefit[index].ranking
    },
    async getAllDataCategoryLoyalty () {
      let orderType = this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
      let outletCode = this.$disposition.getByKey(this, 'outletCode', '')
      if (this.$route.query.isApp === '1') {
        orderType = this.$route.query.orderType || orderType
        outletCode = this.$route.query.outletCode || outletCode
      }
      const vm = this
      try {
        vm.dataCategory = []
        let params = {
          order_time: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
          order_type: orderType,
          outlet_code: outletCode,
          lang: vm.$session.get('lang'),
          membership_id: 1,
          hide: 0
        }
        const response = await vm.axios.apiLoyalty.getAllCategoryLoyalty(params)
        const data = vm.getValueFromAttr(response, 'data.data.items', [])
        data.forEach(async element => {
          await vm.getDataItemsLoyalty(element, element.uuid)
        })
        vm.dataCategory = data
      } catch (error) {
        console.log(`Error function getAllDataCategoryLoyalty ${error}`)
      }
    },
    async getDataItemsLoyalty (item) {
      const vm = this
      try {
        item.dataItems = []
        if (!item) {
          return
        }
        const params = vm.getMenuRequest(item.uuid, '')
        const response = await vm.axios.apiLoyalty.getFreeItemsLoyalty(params)
        const data = vm.getValueFromAttr(response, 'data.data.items', [])
        data.forEach(element => {
          if (element.customize && element.customize.hide_without_store) {
            return false
          } else {
            const point = vm.getValueFromAttr(element, 'point', 0)
            item.dataItems.push({
              uuid: vm.getValueFromAttr(element, 'uuid'),
              logo: vm.getValueFromAttr(element, 'image.mobile_detail'),
              title: vm.getValueFromAttr(element, 'name'),
              price: point + ' ' + vm.$tc('slices', point)
            })
          }
        })
      } catch (error) {
        console.log(`Error function getDataItemsLoyalty ${error}`)
      }
    },
    generateCategory () {
      const vm = this
      return this.dataCategory.filter(function (item, index) {
        return vm.ranking <= item.membership_id
      })
    },
    generateItems (category) {
      return this.getValueFromAttr(category, 'dataItems', [])
    }
  }
}

</script>

<style scoped>
  .container-hut-rewards-detail {
    width: 500px;
    position: relative;
    z-index: 1;
  }
  .container-hut-rewards-detail .container-top .text-title {
    font-size: 24px;
    line-height: 24px;
  }
  .container-hut-rewards-detail .container-top .text-reward {
    letter-spacing: 5px;
  }
  .container-hut-rewards-detail .container-top .text-small-top-right {
    margin-top: -8px;
    margin-left: -4px;
    font-size: 7px;
  }
  .container-hut-rewards-detail .container-accordion .container-item .container-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    cursor: pointer;
    width: 100%;
  }
  @media (max-width: 768px) {
    .container-hut-rewards-detail {
      width: 350px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/HutRewardsDetail.vue